import { componentQrl, inlinedQrl, useSignal, useStore, useVisibleTaskQrl, useLexicalScope, _jsxQ, _fnSignal } from "@builder.io/qwik";
import { isEditing } from "../../functions/is-editing.qwik.mjs";
import { logger } from "../../helpers/logger.qwik.mjs";
const runScripts = function runScripts2(props, state, elementRef) {
  if (!elementRef.value || !elementRef.value.getElementsByTagName || typeof window === "undefined")
    return;
  const scripts = elementRef.value.getElementsByTagName("script");
  for (let i = 0; i < scripts.length; i++) {
    const script = scripts[i];
    if (script.src) {
      if (state.scriptsInserted.includes(script.src))
        continue;
      state.scriptsInserted.push(script.src);
      const newScript = document.createElement("script");
      newScript.async = true;
      newScript.src = script.src;
      document.head.appendChild(newScript);
    } else if (!script.type || [
      "text/javascript",
      "application/javascript",
      "application/ecmascript"
    ].includes(script.type)) {
      if (state.scriptsRun.includes(script.innerText))
        continue;
      try {
        state.scriptsRun.push(script.innerText);
        new Function(script.innerText)();
      } catch (error) {
        logger.warn("[BUILDER.IO] `CustomCode`: Error running script:", error);
      }
    }
  }
};
const CustomCode = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  const elementRef = useSignal();
  const state = useStore({
    scriptsInserted: [],
    scriptsRun: []
  });
  useVisibleTaskQrl(/* @__PURE__ */ inlinedQrl(() => {
    const [elementRef2, props2, state2] = useLexicalScope();
    runScripts(props2, state2, elementRef2);
  }, "CustomCode_component_useVisibleTask_S5QgEQZj6YE", [
    elementRef,
    props,
    state
  ]));
  useVisibleTaskQrl(/* @__PURE__ */ inlinedQrl(({ track }) => {
    const [elementRef2, props2, state2] = useLexicalScope();
    track(() => props2.code);
    if (isEditing())
      runScripts(props2, state2, elementRef2);
  }, "CustomCode_component_useVisibleTask_1_Re102EQisCE", [
    elementRef,
    props,
    state
  ]));
  return /* @__PURE__ */ _jsxQ("div", {
    ref: elementRef
  }, {
    class: _fnSignal((p0) => "builder-custom-code" + (p0.replaceNodes ? " replace-nodes" : ""), [
      props
    ], '"builder-custom-code"+(p0.replaceNodes?" replace-nodes":"")'),
    dangerouslySetInnerHTML: _fnSignal((p0) => p0.code, [
      props
    ], "p0.code")
  }, null, 3, "bY_0");
}, "CustomCode_component_uYOSy7w7Zqw"));
export {
  CustomCode,
  CustomCode as default,
  runScripts
};
